import axios from 'axios';
const pending = new Map();
// In-flight only: no stale cache after saves or environment switches.
/** Purpose: share an in-flight GET for the same URL and authorization context. Why: prevents concurrent screens from duplicating reads without caching stale data after edits. */
export function deduplicatedGet(url) {
  const key = `${axios.defaults.headers.common.Authorization || ''}:${url}`;
  if (!pending.has(key)) {
    pending.set(key, axios.get(url).finally(() => pending.delete(key)));
  }
  return pending.get(key);
}
